import { jsx as _jsx } from "react/jsx-runtime";
import { Row } from "@faire/web--source/slate/Layout";
import React from "react";
import { RatingDisplay } from "@faire/retailer/components/RatingStars/RatingDisplay";
export var BrandOverallRating = function(props) {
    return /*#__PURE__*/ _jsx(Row, {
        align: "center",
        children: /*#__PURE__*/ _jsx(RatingDisplay, {
            rating: props.rating
        })
    });
};
